import { IBasicReturn } from '@interfaces/IBasicReturn';
import { IPagination } from '@interfaces/IPagination';
import { IUser } from '@interfaces/IUser';
import appAxiosInstance from '@utils/appAxiosInstance';

const getUsers = async (page: IPagination): Promise<IBasicReturn<IPagination<IUser[]>>> => {
  let users: IBasicReturn<IPagination<IUser[]>> = {
    Success: true,
  };

  await appAxiosInstance()
    .get<IBasicReturn<IPagination<IUser[]>>>(`Identity/UsersForAdminView/${page.Page}/${page.PageSize}`)
    .then((response): IBasicReturn<IPagination<IUser[]>> => {
      const { data } = response;

      users = data;

      return users;
    })
    .catch((): IBasicReturn<IPagination<IUser[]>> => {
      users.Success = false;

      return users;
    });

  return users;
};

export default getUsers;
